<template>
  <div class="videoList">
    <div class="top-wrapper">
      <div class="top" v-for="item in topList.slice(0,1)" :key="item.key">
        <router-link :to="{
              name:'Video',
              params:{
                id:item.id
              }
            }">
          <div class="top-img-wrapper">
            <img :src="item.picture" alt="" class="top-img">
          </div>
          <div class="info">
            <p style="  margin-left: .08rem; font-size: .32rem;white-space: nowrap;width: 7rem;overflow: hidden;text-overflow: ellipsis">{{item.title}}</p>
          </div>
        </router-link>
      </div>
      <div class="middle">
        <div v-for="item in topList.slice(2,4)" class="middle-wrapper">
          <router-link :to="{
              name:'Video',
              params:{
                id:item.id
              }
            }">
            <div class="middle-img-wrapper">
              <img :src="item.picture" style="width: 100%" :alt="item.title" class="middle-img">
            </div>
            <div>
              <p class="yp-title">艺人专访</p>
              <p class="yp-content">{{item.title}}</p>
            </div>
          </router-link>
        </div>
      </div>


    </div>
    <div class="bottom">
      <div v-for="item in hotList" class="bottom-wrapper">
        <router-link :to="{
              name:'Video',
              params:{
                id:item.id
              }
            }">
          <div class="bottom-content">
            <div class="bottom-img-wrapper">
              <img :src="item.picture" :alt="item.title" class="bottom-img">
            </div>
            <div class="bottom-info">
              <p class="yp-title">艺人专访</p>
              <p style="font-size: .3rem; overflow: hidden;text-overflow: ellipsis;width: 4.2rem">{{item.title}}</p>
            </div>
          </div>

        </router-link>
        <div class="line"></div>
      </div>
      <v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false"
              @page-change="pageChange"></v-page>
    </div>


  </div>
</template>

<script>
  export default {
    name: "VideoList",
    data() {
      return {
        info: {},
        totalRow: 100,
        pageArr: [],
        pageNum: 1,
        hotList: [],
        seoList: [],
        topList: []
      }
    },
    metaInfo() {
      return {
        title: this.seoList.column_title?`${this.seoList.column_title}-打造影视行业优秀的资源聚合服务平台` : '',
        meta: [{
          name: 'keywords',
          content: this.seoList.column_keywords || ''
        },
          {
            name: 'description',
            content: this.seoList.column_description || ''
          }]
      }
    },
    methods: {
      pageChange(pInfo) {
        pInfo.pageSize = 10//显示count数量
        this.pageNum = pInfo.pageNumber //页码
        this.$http.get('https://api.yopoo.cn/api/v1/visit?page=' + this.pageNum + '&count=' + pInfo.pageSize)
          .then((res) => {
            this.hotList = res.data.data
            this.pageArr = res.data.pagination //返回分页数组
            this.totalRow = res.data.pagination.total
          }, (err) => {
            console.log(err)
          })
        this.info = pInfo

      },
      getTop() {
        let topApi = 'https://api.yopoo.cn/api/v1/hotvisit?count=6'
        this.$http.get(topApi)
          .then((res) => {
            this.topList = res.data.data
          })
      },
      getSeo() {
        let seoApi = 'https://api.yopoo.cn/api/v1/visit?page=1&count=12&column=1'
        this.$http.get(seoApi)
          .then((res) => {
            this.seoList = res.data.metas
          }, err => {
            console.log(err)
          })
      },
      getHotData() {
        var hotApi = 'https://api.yopoo.cn/api/v1/visit';
        this.$http.get(hotApi, {
          params: {
            page: 1,
            count: 11,
            column: 1
          }
        }).then((res) => {
            this.hotList = res.data.data
          },
          err => {
            console.log(err)
          }
        )
      }
    },
    beforeMount() {
      // this.getHotData()
      this.getSeo()
      this.getTop()
    }
  }
</script>

<style scoped>
  .top-wrapper {
    background: #fff;

  }

  .top-wrapper {
    padding: 0 .23rem;
  }

  .top-img-wrapper {

  }

  .top {
    position: relative;
    display: block;

  }

  .top-img {
    width: 100%;
    height: auto;
    vertical-align: bottom;
  }

  .info {
    position: absolute;
    top: 83%;
    left: 0;
    right: 0;
    bottom: 0;
    color: white;
    background: rgba(0, 0, 0, 0.5);
    height: 17%;
    font-size: .20rem; /*rem*/
    display: flex;
    align-items: center;
  }

  .middle {
    display: flex;
    justify-content: space-around;
    padding: .33rem 0;
  }

  .middle-img-wrapper {

  }

  /*@media only screen and (max-width: 361px) {*/
  /*.middle-img-wrapper{*/
  /*width: 3.3rem;*/
  /*height: 2.56rem;*/
  /*}*/
  /*}*/

  .middle-img {
    width: 3.45rem;
    height: 2.56rem;

  }

  .middle-wrapper:nth-child(2) {
    padding-left: .14rem;
  }

  .bottom {
    background: #fff;
    padding: 0 .23rem;
    margin-top: .20rem;
    padding-bottom: .25rem;
  }

  .bottom-content {
    display: flex;
  }

  .bottom-img-wrapper {

  }

  .bottom-img {
    width: 2.5rem;
    height: 1.5rem;
  }

  .bottom-wrapper {
    padding: .16rem 0;

  }

  .bottom-info {
    margin-left: .23rem;
  }

  .line {
    height: .01rem;
    background: #D9D9D9;
    margin: 0 .23rem;
  }

  .yp-title {
    font-size: .3rem;
    font-weight: bold;
  }

  .yp-content {
    font-size: .28rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/VideoList.vue